import { Col, Row, Affix } from "antd";
import TreatmentJourney from "../components/orders/TreatmentJourney";
import PastOrders from "../components/orders/PastOrders";
import StageZero from "../components/orders/StageZero";
import StageOne from "../components/orders/StageOne";
import StageTwo from "../components/orders/StageTwo";
import StageThree from "../components/orders/StageThree";
import StageRefund from "../components/orders/StageRefund";

export default function OrderTrackingPg() {
  return (
    <div className="w-full min-h-screen bg-white p-6 lg:p-12">
      <div className="max-w-[1600px] mx-auto">
        <Row gutter={[48, 48]}>
          {/* Left Sidebar */}
          <Col xs={24} lg={8} xl={6}>
            <Affix offsetTop={24}>
              <div className="flex flex-col gap-8">
                <TreatmentJourney />
                <PastOrders />
              </div>
            </Affix>
          </Col>
          
          {/* Main Content */}
          <Col xs={24} lg={16} xl={18}>
            <StageRefund />
            <StageZero />
            <StageOne />
            <StageTwo />
            <StageThree />  
          </Col>
        </Row>
      </div>
    </div>
  );
}
